import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './login.service'
import * as $ from 'jquery';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonUtilitiesService } from '../common-utilities.service';
import { constants } from '../constants';
import { PrivacyService } from '../privacy/privacy.service';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  //variables del formulario
  loginForm: FormGroup;
  numericPattern = constants.REGEX_NUMERIC_PATTERN;
  alphanumericPattern = constants.REGEX_ALPHANUMERIC_PATTERN;
  emailPattern = constants.REGEX_EMAIL_PATTERN;
  //variables del modal
  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  //variables generales
  isCodeSent = false;
  isBtnEnabled = false
  isSendCode = true;
  isBtnDisabled = false;
  isTermsChecked = false
  isRegisterProcess = false;

  mainPhone = null;
  mainMail = null;

  linkCookies:any 
  linkPolicy:any 

  phoneShowText = "";

  //constructor del componente
  constructor(  public LANG: CommonUtilitiesService, 
                private _router: Router, 
                private formbuilder: FormBuilder, 
                private loginService: LoginService,
                private privacyService:PrivacyService
              ) { }

  /**
   * Description: Método que inicializa las variables y validaciones del formulario
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  ngOnInit() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    //valida si existe una sesión activa 
    this.validateActiveSession();
    this.setOnclickEvents();
    this.getLinksDocument()
    this.loginForm = this.formbuilder.group({
      inputCC: ['', [Validators.required, Validators.pattern(this.alphanumericPattern)]],
      inputCel: ['', [Validators.required, Validators.pattern(this.numericPattern)]],
      inputMail: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      inputPIN: ['', [/*Validators.required, Validators.pattern(this.numericPattern)*/]],
      inputMainEmail: ['', /*[Validators.pattern(this.emailPattern)]*/],
      inputMainPhone: ['', /*[Validators.required, Validators.pattern(this.numericPattern)]*/],
      inputDocumentType: [constants.TYPE_CED /*, [Validators.required]*/],
      inputAcceptTerms: ['', [Validators.required] ]
    });
  }

  /**
  * Description: Método que valida si existe una session activa
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  validateActiveSession() {
    if (this.LANG.isLogged()) {
      this._router.navigate([constants.ROUTE_URL_MY_ACCOUNT]);
    }
  }

  /**
  * Description: Método que valida los datos del paso 1 y envía el SMS con el código de validación
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  validateRegisteredUser() {
    // Validación de campos paso 1
    if (this.loginForm.get('inputCC').invalid || this.loginForm.get('inputDocumentType').invalid) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
      this.isShowModal = true;
      return;
    }

    if (!this.isRegisterProcess) {
      this.isBtnDisabled = true;
      //procesar envio sms validación

      this.loginService.validateUserMainInformation((this.loginForm.get('inputCC').value).trim(), this.loginForm.get('inputDocumentType').value).subscribe((valData => {
        this.isBtnDisabled = false;


        if (valData['responseCode'] == constants.NO_DATA_FOUND_WS_RESPONSE_CODE) {
          //si es un registro pero NO ingreso todos los datos inicalmente
          this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
          this.modalContent = this.LANG.getLangText('LOGIN_LABEL_MODAL_CONTENT_USER_NOT_REGISTERED');
          this.isShowModal = true;
          return false;
        }

        if (valData['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {

          let mainEmail = valData["obj"].email;
          let mainPhone = valData["obj"].mainPhone;

          if ((mainEmail == true || mainEmail == "true") && mainPhone != null) {
            this.mainPhone = mainPhone;
            this.mainMail = mainEmail;
            this.phoneShowText = mainPhone;
            //si el usuario esta registrado y tiene todos los datos bien
            this.sendValidationCode(this.loginForm.get('inputCC').value, "");

          } else if ((mainEmail == true || mainEmail == "true") && mainPhone == null) {
            this.mainPhone = null;
            this.mainMail = mainEmail;
            if (!this.loginForm.get('inputCC').invalid
              && !this.loginForm.get('inputCel').invalid) {
              this.sendValidationCode(this.loginForm.get('inputCC').value, this.loginForm.get('inputCel').value);
            } else {
              //si es un registro pero NO ingreso todos los datos inicalmente
              this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
              this.modalContent = this.LANG.getLangText('LOGIN_LABEL_MODAL_CONTENT_USER_NOT_REGISTERED_MAIN_DATA_PHONE');
              this.isShowModal = true;
              return false;
            }

          } else {
            //si el usuario esta registrado y no tiene EMAIL principal asignado 
            this.isRegisterProcess = true;

            if (!this.loginForm.get('inputCC').invalid
              && !this.loginForm.get('inputCel').invalid
              && !this.loginForm.get('inputMail').invalid) {
              //si es un registro pero ya ingreso todos los datos inicalmente
              this.sendValidationCode(this.loginForm.get('inputCC').value, this.loginForm.get('inputCel').value);
            } else {
              //si es un registro pero NO ingreso todos los datos inicalmente
              this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
              this.modalContent = this.LANG.getLangText('LOGIN_LABEL_MODAL_CONTENT_USER_NOT_REGISTERED_MAIN_DATA_ALL');
              this.isShowModal = true;
              return false;
            }
          }
        }
        //Validación cuando el WS responde con diferente a "00" o "-4"
        if (valData['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
          this.modalTitle = this.LANG.getLangText('LOGIN_ERROR_UNEXPECTED');
          this.modalContent = this.LANG.getLangText('LOGIN_ERROR_VALIDATION_USER');
          this.isShowModal = true;
          return false;
        }
      }),
        (err) => {
          this.isBtnDisabled = false;
          this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
          this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
          this.isShowModal = true;
        });

    } else {
      // Validación de campos paso 1 cuando el user esta registrado pero no tiene datos registrados
      if (this.loginForm.get('inputCC').invalid
        || this.loginForm.get('inputCel').invalid
        || this.loginForm.get('inputMail').invalid) {
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
        this.isShowModal = true;
        return;
      }
      this.sendValidationCode(this.loginForm.get('inputCC').value, this.loginForm.get('inputCel').value);
    }
  }

  /**
  * Description: Método que envía el código de verificación de login
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  sendValidationCode(documentId, phone) {

    if (!this.LANG.isValidPhoneZero(phone)) {
      //si no tiene el prefijo 0 no puede seguir
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PHONE_VALIDATOR_ERROR_ZERO');
      this.isShowModal = true;
      return false;
    }

    //procesar envio sms validación
    this.isBtnDisabled = true;
    this.loginService.sendValidationCodeBySMS(documentId.trim(), phone.trim(), this.loginForm.get('inputDocumentType').value).subscribe((data => {
      //habilitar botones
      this.isBtnDisabled = false;
      if (data['responseCode'] == constants.SESSION_DUPLICATE) {
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('LOGIN_LABEL_DUPLICATE_SESSION');
        this.isShowModal = true;
        return;
      }
      if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
        this.modalTitle = this.LANG.getLangText('LOGIN_LABEL_MODAL_ERROR_SMS_TITLE');
        this.modalContent = this.LANG.getLangText('LOGIN_LABEL_MODAL_ERROR_SMS_CONTENT');
        this.isShowModal = true;
        return;
      }

      //texto para saber a que numero se envio el pin
      if (this.phoneShowText == "") {
        this.phoneShowText = phone;
      }

      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_INFO');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_SEND_CODE') + " " + this.phoneShowText;
      //oculata el primer paso
      this.isSendCode = false;
      //muestra el segundo paso
      this.isCodeSent = true;
      //muestra el modal
      this.isShowModal = true;

    }),
      (err) => {
        this.isBtnDisabled = false;
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
      });
  }

  /**
  * Description: Método que indica que se actualizó la cedula
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  updateCC() {
    this.isRegisterProcess = false;
  }

  /**
  * Description: Método que valida los datos del paso 2 y valida el código de validación enviado por SMS
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  login() {
    // Validación de campos paso 2
    if (this.loginForm.get('inputPIN').invalid) {
      this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
      this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
      this.isShowModal = true;
      return;
    }

    this.isBtnDisabled = true;
    //procesar envio sms validación
    this.loginService.validateSMSCode(
      this.loginForm.get('inputCC').value,
      this.loginForm.get('inputPIN').value,
      this.loginForm.get('inputDocumentType').value).subscribe((data => {

        //reintentos agotados
        if (data['responseCode'] == constants.LOGIN_RETRY_LIMIT_CODE) {
          this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
          this.modalContent = this.LANG.getLangText('LOGIN_LABEL_RETRY_LIMIT');
          this.isShowModal = true;
          this.isSendCode = true;
          this.isCodeSent = false;
          this.isBtnDisabled = false;
          this.loginForm.patchValue({ inputPIN:""});
          return; 
        }
        
        //otros errores
        if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
          this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
          this.modalContent = this.LANG.getLangText('LOGIN_LABEL_WRONG_PIN');
          this.isShowModal = true;
          //habilitar botones
          this.isBtnDisabled = false;
          return;
        }

        //se guarda la información del usuario logueado en sesión
        data['obj'].isMainPhone = true;
        if (this.mainPhone == null) {
          data['obj'].phone = (this.loginForm.get('inputCel').value).trim();
          data['obj'].isMainPhone = false;
        }

        if (this.mainMail == null) {
          data['obj'].email = (this.loginForm.get('inputMail').value).trim();
        }

        localStorage.setItem("userData", JSON.stringify(data['obj']));
        if (this.isRegisterProcess) {
          //se actualizan los datos requeridos en caso de que sea primera vez
          let accountId = data['obj'].billingAccountId;
          this.updateUserMainData(accountId);
        } else {
          this._router.navigate([this.loginService.getUrlToRedirect()]);
        }
        this.saveAcceptPolicy(data['obj'])
      }),
        (err) => {
          this.isBtnDisabled = false;
          this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
          this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
          this.isShowModal = true;
        });
  }

  /**
   * Description: Método que actualiza número y email principal
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  updateUserMainData(accountId) {
    //actualiza datos en WS
    this.loginService.updateUserMainInfo(accountId, this.loginForm.get('inputMail').value).subscribe((data => {
      this._router.navigate([this.loginService.getUrlToRedirect()]);
    }),
      (err) => {
        this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
        this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
        this.isShowModal = true;
        this.isBtnDisabled = false;
      });
  }

  saveAcceptPolicy(userData : any){
    let objectToSave = this.setObjectSaveAccept(userData)
    this.loginService.saveAcceptPolicy(objectToSave).subscribe(((dataResponse:any) => {
      
      if (dataResponse['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE) {  
          console.log(dataResponse);
      }
    }))
  }
  getLinksDocument(){

    this.privacyService.getAllPolicy().subscribe(((dataResponse:any) => {
      
      if (dataResponse['responseCode'] ==  constants.SUCCESS_WS_RESPONSE_CODE) {  
        dataResponse.obj.forEach(element => {
          if (element.policyType.includes("COOKIES")) {
            this.linkCookies = element.documentLink.link
          }
          if (element.policyType.includes("PRIVACIDAD")) {
            this.linkPolicy = element.documentLink.link
          }
        });
      }
    }))
  }

  setObjectSaveAccept(userData:any){
    return {
      "tradeMark": "Maxiplus",
      "acceptChannel": "WEB",
      "documentType": userData.documentType,
      "document": userData.documentId,
      "phoneNumber": userData.phone
    }
  }

  /**
   * Description: Método que envía el codigo de validación por SMS
   * Autor: Diego Diaz
   * @param N/A
   * @return N/A
   */
  hideModal() {
    this.isShowModal = false;
  }

  /**
  * Description: Método que inicializa los eventos onlick
  * Autor: Diego Diaz
  * @param N/A
  * @return N/A
  */
  setOnclickEvents() {
    $(document).ready(function () {
      $("input").focus(function (e) {
        $('#' + e.target.id).parent().closest('div').addClass('focused');
      });
      $("input").focusout(function (e) {
        if ($('#' + e.target.id).val() == "") {
          $('#' + e.target.id).parent().closest('div').removeClass('focused');
        }
      });
    });
  }

  clickCheckTerms(event){
    if(!event.target.checked){
      this.isTermsChecked = false
      return
    }
    this.isTermsChecked = true
    
  }
}
